import React from 'react'
import styled from 'styled-components'

const Index = styled.section`
  margin-top: 1rem;
  @media (min-width: 40rem) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 100vh;
    margin-top: 0;
  }
`
const Heading = styled.h1`
  color: #ffe4b0;
  font-size: 4rem;
  margin-bottom: 2rem;
`
const Links = styled.div`
  margin: 3rem 0;
  display: flex;
  flex-wrap: wrap;
`
const ButtonLink = styled.a`
  color: #fff;
  margin: 0 .2rem;
  padding: .6rem 1.4rem;
  font-size: 1.3rem;
  margin-bottom: 1rem;
  transition: all .15s ease-in;
  text-decoration: none;
  background-color: #e25a40;
  border-radius: 50px;
  &:hover {
    background-color: #dc7a67;
  }
`
const Text = styled.p`
  color: ${props => props.subtle ? '#949db3' : '#eee'};
  font-size: ${props => props.large ? '1.8rem' : '1.2rem'};
  margin-bottom: 1.2rem;
`

const IndexPage = () => (
  <Index>
    <Heading>👋 Hello, I'm Patrik</Heading>
    <Text large>🏢 Frontend @ Hemnet</Text>
    <Text large>🌍 Stockholm, Sweden</Text>
    <Links>
      <ButtonLink href="https://github.com/wibron">Github</ButtonLink>
      <ButtonLink href="https://twitter.com/wibron">Twitter</ButtonLink>
      <ButtonLink href="https://www.linkedin.com/in/patrikwibron/">LinkedIn</ButtonLink>
      <ButtonLink href="mailto:patrik@wibron.nu">Mail</ButtonLink>
    </Links>
  </Index>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js